import { colorPrimatives } from "./colorPrimatives";

export const rpaLightTheme = {
  icon: {
    success: colorPrimatives.light.green[700],
    warning: colorPrimatives.light.yellow[700],
    disabled: colorPrimatives.light.gray[500],
    bold: colorPrimatives.light.gray[900],
    inverse: colorPrimatives.light.gray[50],
    subtle: colorPrimatives.light.gray[700],
    brand: colorPrimatives.light.rpa[700],
    danger: colorPrimatives.light.red[700],
    info: colorPrimatives.light.blue[600],
    link: colorPrimatives.light.blue[600],
    linkHover: colorPrimatives.light.blue[800],
    linkActive: colorPrimatives.light.blue[950],
    subtleHover: colorPrimatives.light.gray[800],
    subtleActive: colorPrimatives.light.gray[900],
    inverseSubtle: colorPrimatives.light.gray[500],
    inverseSubtleHover: colorPrimatives.light.gray[600],
    inverseSubtleActive: colorPrimatives.light.gray[700],
    accent: {
      purple: colorPrimatives.light.purple[700],
      green: colorPrimatives.light.green[400],
      orange: colorPrimatives.light.yellow[700],
      red: colorPrimatives.light.red[700],
      blue: colorPrimatives.light.blue[400],
    },
  },
  bg: {
    danger: colorPrimatives.light.red[700],
    dangerHover: colorPrimatives.light.red[800],
    dangerActive: colorPrimatives.light.red[900],
    dangerSubtlest: colorPrimatives.light.red[100],
    brand: colorPrimatives.light.rpa[700],
    brandSubtlest: colorPrimatives.light.rpa[50],
    brandHover: colorPrimatives.light.rpa[800],
    brandActive: colorPrimatives.light.rpa[900],
    surface: colorPrimatives.light.white,
    surfaceSunken: colorPrimatives.light.gray[200],
    surfaceRaised: colorPrimatives.light.white,
    surfaceBold: colorPrimatives.light.gray[950],
    surfaceOverlay: colorPrimatives.light.white,
    surfaceBoldBrand: colorPrimatives.light.blue[950],
    neutralDisabled: colorPrimatives.light.gray[200],
    // neutral: "#ffffff", // TODO no matching primative
    // neutralHover: "#ffffff", // TODO no matching primative
    // neutralActive: "#ffffff", // TODO no matching primative
    // neutralSelected: "#ffffff", // TODO no matching primative
    // neutralInverse: "#000000", // TODO no matching primative
    // neutralInverseHover: "#000000", // TODO no matching primative
    // neutralInverseActive: "#000000", // TODO no matching primative
    // neutralInverseSelected: "#000000", // TODO no matching primative
    // neutralInvertedDisabled: "#000000", // TODO no matching primative
    grayBold: colorPrimatives.light.gray[950],
    grayBoldHover: colorPrimatives.light.gray[800],
    grayBoldActive: colorPrimatives.light.gray[600],
    graySubtle: colorPrimatives.light.gray[300],
    graySubtleHover: colorPrimatives.light.gray[400],
    graySubtleActive: colorPrimatives.light.gray[500],
    graySubtler: colorPrimatives.light.white,
    graySubtlerHover: colorPrimatives.light.gray[50],
    graySubtlerActive: colorPrimatives.light.gray[200],
    graySubtlest: colorPrimatives.light.gray[150],
    success: colorPrimatives.light.green[700],
    successHover: colorPrimatives.light.green[800],
    successActive: colorPrimatives.light.green[900],
    successSubtlest: colorPrimatives.light.green[100],
    warning: colorPrimatives.light.yellow[700],
    warningHover: colorPrimatives.light.yellow[800],
    warningActive: colorPrimatives.light.yellow[900],
    warningSubtlest: colorPrimatives.light.yellow[100],
    info: colorPrimatives.light.blue[600],
    infoHover: colorPrimatives.light.blue[800],
    infoActive: colorPrimatives.light.blue[950],
    infoSubtlest: colorPrimatives.light.blue[100],
    input: colorPrimatives.light.white,
    inputHover: colorPrimatives.light.gray[50],
    accent: {
      purple: colorPrimatives.light.purple[400],
      purpleSubtlest: colorPrimatives.light.purple[50],
      green: colorPrimatives.light.green[400],
      greenSubtlest: colorPrimatives.light.green[50],
      orange: colorPrimatives.light.yellow[200],
      orangeSubtlest: colorPrimatives.light.yellow[100],
      red: colorPrimatives.light.red[400],
      redSubtlest: colorPrimatives.light.red[50],
      blue: colorPrimatives.light.blue[400],
      blueSubtlest: colorPrimatives.light.blue[50],
    },
  },
  text: {
    brand: colorPrimatives.light.rpa[700],
    disabled: colorPrimatives.light.gray[600],
    subtle: colorPrimatives.light.gray[800],
    bold: colorPrimatives.light.gray[950],
    inverse: colorPrimatives.light.white,
    inverseSubtle: colorPrimatives.light.gray[500],
    danger: colorPrimatives.light.red[700],
    success: colorPrimatives.light.green[700],
    warning: colorPrimatives.light.yellow[700],
    info: colorPrimatives.light.blue[700],
    link: colorPrimatives.light.rpa[700],
    linkHover: colorPrimatives.light.rpa[800],
    linkActive: colorPrimatives.light.rpa[900],
    linkInlineHover: colorPrimatives.light.gray[800],
    linkInlineActive: colorPrimatives.light.gray[600],
    accent: {
      purple: colorPrimatives.light.purple[600],
      green: colorPrimatives.light.green[400],
      orange: colorPrimatives.light.yellow[700],
      red: colorPrimatives.light.red[700],
    },
  },
  border: {
    subtle: colorPrimatives.light.gray[400],
    bold: colorPrimatives.light.gray[950],
    inverse: colorPrimatives.light.gray[50],
    brand: colorPrimatives.light.rpa[700],
    danger: colorPrimatives.light.red[700],
    success: colorPrimatives.light.green[700],
    warning: colorPrimatives.light.yellow[700],
    info: colorPrimatives.light.blue[600],
    focus: colorPrimatives.light.blue[400],
    link: colorPrimatives.light.blue[600],
    linkHover: colorPrimatives.light.blue[800],
    linkActive: colorPrimatives.light.blue[950],
    accent: {
      blue: colorPrimatives.light.blue[600],
      purple: colorPrimatives.light.purple[600],
      green: colorPrimatives.light.green[400],
      orange: colorPrimatives.light.yellow[700],
      red: colorPrimatives.light.red[700],
    },
  },
} as const;
